import { Dialog, styled } from "@mui/material";

export const ConfirmationDialogStyled = styled(Dialog)(() => ({
  maxWidth: "360px",
  margin: "auto",
  gap: "20px",
  '& .MuiDialogTitle-root': {
    color: " var(--Schemes-On-Surface-Variant)",
    textAlign: "center",
    fontSize: "20px",
    fontWeight: 800,
    fontStyle: "normal",
    lineHeight: "24px",
  },
  '& .MuiDialogContent-root': {
    color: " var(--Schemes-On-Surface-Variant)",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  '& .MuiDialogActions-root': {
    alignItems: "center",
    justifyContent: "space-around",
  },
}));